import React, { } from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Card,
  Button,
} from '@lockerpm/design';

import {
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

import { red } from '@ant-design/colors';

import global from "../../../../../config/global";
import workspaceServices from "../../../../../services/workspace";
import commonServices from "../../../../../services/common";

const DangerZone = (props) => {
  const { t } = useTranslation()

  const {
    className = '',
    workspace = {}
  } = props;


  const handleDelete = () => {
    global.confirm(() => {
      workspaceServices.remove(workspace.id).then(async () => {
        global.notification('success', t('notification.success.title'), t('notification.success.workspace.deleted'));
        await commonServices.sync_profile();
        await commonServices.sync_data({ isDelete: true });
      }).catch((error) => {
        global.pushError(error)
      });
    });
  };

  return (
    <div className={className}>
      <Card
        style={{
          borderColor: red.primary
        }}
      >
        <div className="flex justify-between">
          <div>
            <div
              className="flex"
              style={{ color: red.primary }}
            >
              <InfoCircleOutlined
                className="mr-1"
              />
              <p className="font-bold">
                {t('information.danger_zone')}
              </p>
            </div>
            <p className="mt-1">
              {t('information.danger_zone_description')}
            </p>
          </div>
          <Button
            type="primary"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete()}
          >
            {t('button.delete')}
          </Button>
        </div>
      </Card>
    </div>
  );
}

export default DangerZone;
